<template>
	<v-card class="elevation-1">
		<v-card-title>
			<h4>
				{{ index }}. Gebinde <span style="font-size: 0.7em"> {{ gebinde.name }}</span>
			</h4>
		</v-card-title>
		<v-form v-model="valid" ref="gebindeForm">
			<v-container grid-list-md>
				<v-layout row wrap>
					<v-flex xs12 sm6>
						<v-text-field
							v-model="gebinde.weight"
							label="Gewicht [kg]"
							type="number"
							:rules="weightRules"
							required
						></v-text-field>
					</v-flex>
					<v-flex xs12 sm6 v-show="isLkw">
						<v-text-field
							v-model="gebinde.timeEffort"
							label="Zeitaufwand [Min.]"
							type="number"
							:rules="timeEffortRules"
							required
						></v-text-field>
					</v-flex>
				</v-layout>
				<v-layout row wrap>
					<v-flex
						xs12
						sm4
						v-if="
							gebinde.gebindeDetailDefinition == 3 ||
							gebinde.gebindeDetailDefinition == 2
						"
					>
						<v-text-field
							v-model="gebinde.length"
							@blur="gebinde.length = Math.ceil(gebinde.length)"
							label="Länge [cm]"
							type="number"
							:rules="lengthRules"
							required
						></v-text-field>
					</v-flex>
					<v-flex
						xs12
						sm4
						v-if="
							gebinde.gebindeDetailDefinition == 3 ||
							gebinde.gebindeDetailDefinition == 2
						"
					>
						<v-text-field
							v-model="gebinde.width"
							@blur="gebinde.width = Math.ceil(gebinde.width)"
							label="Breite [cm]"
							type="number"
							:rules="lengthRules"
							required
						></v-text-field>
					</v-flex>
					<v-flex
						xs12
						sm4
						v-if="
							gebinde.gebindeDetailDefinition == 3 ||
							gebinde.gebindeDetailDefinition == 2
						"
					>
						<v-text-field
							v-model="gebinde.height"
							@blur="gebinde.height = Math.ceil(gebinde.height)"
							label="Höhe [cm]"
							type="number"
							:rules="lengthRules"
							required
						></v-text-field>
					</v-flex>
					<!-- Europaletten -->
					<v-flex xs12 sm4 v-if="gebinde.gebindeDetailDefinition == 3">
						<v-text-field
							v-model="gebinde.numberOfEuropalettes"
							label="Anzahl Europaletten"
							type="number"
							:rules="countRules"
							required
						></v-text-field>
					</v-flex>
					<v-flex xs12 sm4 v-if="gebinde.gebindeDetailDefinition == 3">
						<v-text-field
							v-model="gebinde.numberOfEuropalettesFrames"
							label="Anzahl Eurorahmen"
							type="number"
							:rules="countRules"
							required
						></v-text-field>
					</v-flex>
					<v-flex xs12 sm4 v-if="gebinde.gebindeDetailDefinition == 3">
						<v-text-field
							v-model="gebinde.numberOfEuropalettesLid"
							label="Anzahl Eurodeckel"
							type="number"
							:rules="countRules"
							required
						></v-text-field>
					</v-flex>
					<!-- Kosten -->
					<v-flex xs12 sm6 v-if="gebinde.gebindeDetailDefinition == 4">
						<v-text-field
							v-model="gebinde.totalCostForCustomer"
							label="Versandpreis Kunde"
							type="number"
							:rules="costRules"
							hint="Kosten für Verpackungsmaterial und Transport. Ohne Handling und Zeit für Verpacken. Betrag für Rechnung."
							title="Kosten für Verpackungsmaterial und Transport. Ohne Handling und Zeit für Verpacken. Betrag für Rechnung."
							required
						></v-text-field>
					</v-flex>
					<v-flex xs12 sm6 v-if="gebinde.gebindeDetailDefinition == 4">
						<v-text-field
							v-model="gebinde.totalCostForFertiger"
							label="Preis für Fertiger"
							type="number"
							:rules="costRules"
							hint="Dieser Betrag wird dem Fertiger auf der Abrechnung gutgeschrieben."
							title="Dieser Betrag wird dem Fertiger auf der Abrechnung gutgeschrieben."
							required
						></v-text-field>
					</v-flex>
					<!-- Error -->
					<v-flex x12 v-if="packageTooSmall" class="error--text">
						Das Gebinde muss für einen LKW Transport mind. 30kg schwer sein oder in
						mind. einer Dimension grösser als 1m sein.<br />
						Handelt es sich hierbei um einen Spezialfalls, wo ein Transport des Gebindes
						ohne LKW nicht möglich ist, kontaktieren Sie bitte das Blexon Helpdesk.
					</v-flex>
				</v-layout>
			</v-container>
		</v-form>
		<v-card-actions>
			<v-btn
				flat
				class="blexon-button"
				@click="$emit('deletedGebinde', index - 1)"
				v-bind:style="{ visibility: index === 1 ? 'hidden' : 'visible' }"
			>
				Löschen
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import httpClient from "../store/httpClient";

export default {
	props: {
		gebinde: {},
		index: 0,
		weightOfParts: 0,
		maxWeightPerContainer: 0,
		isLkw: false,
	},
	data() {
		return {
			valid: false,
			isAdmin: false,
			weightRules: [
				(v) => !!v || "Gewicht muss angegeben werden.",
				(v) => !isNaN(v) || "Bitte Zahl eingeben",
				(v) =>
					parseFloat(v).toFixed(1) == parseFloat(v) ||
					"Bitte maximal 1 Nachkommastellen angeben",
				(v) => v > 0.9 || "Gewicht muss mindestens 1kg betragen",
				(v) =>
					v < this.maxWeightPerContainer ||
					`Maximalgewicht für diesen Transporteur ist ${this.maxWeightPerContainer}kg.`,
				(v) =>
					v < this.getMaxWeight() ||
					this.canManuallyTransmit ||
					"Gewicht kann nicht höher als Gewicht der Teile mit Verpackung sein.",
			],
			lengthRules: [
				(v) => !!v || "Muss angegeben werden.",
				(v) => !isNaN(v) || "Bitte Zahl (ohne Komma) eingeben",
				(v) => v % 1 === 0 || "Bitte nur Ganzzahlen eingeben",
				(v) => (v > 9 && v < 1000) || "Länge muss zwischen 10cm und 10m liegen",
			],
			countRules: [
				(v) => v !== "" || "Anzahl muss angegeben werden.",
				(v) => !isNaN(v) || "Bitte Zahl (ohne Komma) eingeben",
				(v) => v % 1 === 0 || "Bitte nur Ganzzahlen eingeben",
				(v) => (v >= 0 && v < 100) || "Anzahl muss zwischen 0 und 100 liegen",
			],
			costRules: [
				(v) => v !== "" || "Kosten müssen angegeben werden.",
				(v) => !isNaN(v) || "Bitte Zahl (ohne Komma) eingeben",
				(v) => v % 1 === 0 || "Bitte nur Ganzzahlen eingeben",
				(v) => (v >= 0 && v < 10000) || "Anzahl muss zwischen 0 und 10000 liegen",
			],
			timeEffortRules: [
				(v) => v !== "" || "Zeitaufwand muss angegeben werden.",
				(v) => !isNaN(v) || "Bitte Zahl (ohne Komma) eingeben",
				(v) => v % 1 === 0 || "Bitte nur Ganzzahlen eingeben",
				(v) => !this.isLkw || (v >= 3 && v <= 600) || "Zeit muss zwischen 3 und 600 liegen",
			],
		};
	},
	async mounted() {
		const response = await httpClient().get("api/Capacity/IsUserAdmin");
		this.isAdmin = response.data;
		this.validateForm();
	},
	computed: {
		canManuallyTransmit() {
			return this.$store.getters.currentFertiger(this.$route.params.fertigerId)
				.canManuallyTransmit;
		},

		packageTooSmall() {
			if (this.isAdmin || !this.isLkw) return false; // If user is admin or Gebinde is not for LKW transport, this is irrelevant
			return (
				this.gebinde.weight < 30 &&
				Math.max(this.gebinde.length, this.gebinde.width, this.gebinde.height) < 100
			);
		},
	},
	watch: {
		valid() {
			this.gebinde.valid = this.valid && !this.packageTooSmall;
			this.$emit("validChanged");
		},
		packageTooSmall() {
			this.gebinde.valid = this.valid && !this.packageTooSmall;
			this.$emit("validChanged");
		},
	},
	methods: {
		validateForm() {
			console.log("Validating Gebinde...");
			this.$refs.gebindeForm.validate();
		},

		getMaxWeight() {
			return this.weightOfParts + 80; // 80kg für Palette mit Rahmen (evtl. sogar zwei Rahmen) und Reserve
		},
	},
};
</script>
